<div class="w-full py-5 md:py-15 mt-96 md:mt-0 bg-white">
       <div class="w-full flex flex-col justify-center items-center px-5 md:px-32">
            <h1 class="text-4xl text-center mb-5 text-primary-500 font-medium tracking-wider">Optima Vibe Travel</h1>
            <p class="text-center">Welcome to Optima Travel, your gateway to unforgettable journeys across the globe. Whether you're
                dreaming of luxury rail adventures, ocean cruises, island getaways or all-inclusive escapes, we bring
                you handpicked travel packages tailored to every kind of explorer. From romantic retreats and family
                holidays to bucket-list experiences, our mission is simple: to make travel effortless, affordable, and
                extraordinary. Start planning your next adventure with us, the world is waiting!
            </p>
        </div>
</div>